export default __webpack_public_path__ + "assets/google-play-badge-b8a7e58300e13cc1a9946a0163a88cdf.png";